import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { TermsFormValues } from "../../../types/PitchTypes/PitchTypes";

type UpdateTermsDto = Partial<TermsFormValues>;

interface ApiResponse<T> {
  message: string;
  data: T;
}

export const useSaveMITerms = (
  options?: UseMutationOptions<
    ApiResponse<TermsFormValues>,
    unknown,
    TermsFormValues | UpdateTermsDto | FormData,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: Partial<TermsFormValues> | FormData) => {
      const isFormData = data instanceof FormData;

      // Determine if it's an update or create operation
      const hasId = isFormData
        ? data.get("id") ?? null
        : (data as Partial<TermsFormValues>).id ?? null;

      // Set headers for FormData
      const config = isFormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

      if (hasId) {
        return axiosInstance
          .put(getAPIURL(`/MuslimInvestProfile/Terms/Update`), data, config)
          .then((res) => res.data);
      } else {
        return axiosInstance
          .post(getAPIURL(`/MuslimInvestProfile/Terms/Create`), data, config)
          .then((res) => res.data);
      }
    },
  });
};
